<section class="bg-primary-900">
  <div
    class="px-lg md:px-6xl contact-container flex flex-col justify-between py-6xl">
    <div class="text-white mb-4xl">
      <p class="font-medium mb-lg text-medium">
        {{ 'contact_us_screen_title' | transloco }}
      </p>
      <h4 class="font-bold mb-lg text-heading-6">
        {{ 'contact_us_screen_description' | transloco }}
      </h4>

      <div class="flex gap-lg items-center py-sm">
        <div class="svg-container">
          <mars-email-icon />
        </div>

        <div>
          <p class="text-extra-small">
            {{ 'contact_us_screen_send_email_text' | transloco }}
          </p>
          <p class="font-medium text-medium">
            <a href="mailto:support@contraa.com.sa"
              >support&#64;contraa.com.sa</a
            >
          </p>
        </div>
      </div>

      <div class="flex gap-lg items-center py-sm">
        <div class="svg-container">
          <mars-location-icon color="white" />
        </div>

        <div>
          <p class="text-extra-small">
            {{ 'contact_us_screen_visit_in_person_text' | transloco }}
          </p>
          <p class="font-medium text-medium w-4/5">
            {{ 'contact_us_screen_address' | transloco }}
          </p>
        </div>
      </div>
    </div>

    <div class="form-container bg-white rounded-2xl p-4xl">
      <form [formGroup]="form" (ngSubmit)="submitForm()">
        <div class="mb-2xl">
          <label class="font-medium mb-xs text-small" for="name"
            >{{ 'contact_us_screen_form_name_field_title' | transloco }}*</label
          >
          <mars-input
            inputFormControlName="name"
            [id]="'name'"
            type="text"
            name="name"
            [minlength]="2"
            [maxlength]="100"
            [placeholder]="
              'contact_us_screen_form_name_field_placeholder' | transloco
            " />
          <mars-validation-message
            control="name"
            [label]="'contact_us_screen_form_name_field_title' | transloco" />
        </div>

        <div class="mb-2xl">
          <label class="font-medium mb-xs text-small" for="email"
            >{{
              'contact_us_screen_form_email_field_title' | transloco
            }}*</label
          >
          <mars-input
            inputFormControlName="email"
            [id]="'email'"
            type="email"
            name="email"
            [placeholder]="
              'contact_us_screen_form_email_field_placeholder' | transloco
            " />
          <mars-validation-message
            control="email"
            [label]="'auth_sign_up_screen_email_label' | transloco"
            [customErrorMessages]="{
              pattern:
                ('auth_sign_up_screen_email_validation_pattern' | transloco),
              required:
                ('auth_sign_up_screen_email_validation_required' | transloco),
            }" />
        </div>

        <div class="mb-2xl">
          <label class="font-medium mb-xs text-small" for="phone"
            >{{
              'contact_us_screen_form_phone_field_title' | transloco
            }}*</label
          >
          <ngx-intl-tel-input
            formControlName="phone"
            [cssClass]="'w-full border border-neutral-300 rounded-sm drop-shadow-xs text-small ps-md pe-md'"
            [preferredCountries]="[CountryISO.SaudiArabia]"
            [enableAutoCountrySelect]="true"
            [enablePlaceholder]="true"
            [searchCountryFlag]="true"
            [searchCountryField]="[
              SearchCountryField.Iso2,
              SearchCountryField.Name,
            ]"
            [selectFirstCountry]="false"
            [selectedCountryISO]="CountryISO.SaudiArabia"
            [maxLength]="15"
            [phoneValidation]="true"
            [separateDialCode]="true"
            [numberFormat]="PhoneNumberFormat.National"
            inputId="phone">
          </ngx-intl-tel-input>
          <mars-validation-message
            control="phone"
            [label]="'contact_us_screen_form_phone_field_title' | transloco"
            [customErrorMessages]="{
              validatePhoneNumber:
                'contact_us_screen_form_phone_validation_invalid' | transloco,
            }" />
        </div>

        <div class="mb-4xl">
          <label class="font-medium mb-xs text-small" for="message"
            >{{
              'contact_us_screen_form_message_field_title' | transloco
            }}*</label
          >
          <mars-textarea
            inputFormControlName="message"
            [id]="'message'"
            type="message"
            name="message"
            [minlength]="10"
            [maxlength]="1000"
            [placeholder]="
              'contact_us_screen_form_message_field_placeholder' | transloco
            "
            [rows]="4" />
          <mars-validation-message
            control="message"
            [label]="
              'contact_us_screen_form_message_field_title' | transloco
            " />
        </div>

        <button
          type="submit"
          [disabled]="form.invalid || loading()"
          class="bg-primary-900 font-medium px-2xl py-md rounded-sm text-center text-large text-white w-full disabled:bg-primary-200">
          {{ 'contact_us_screen_form_submit_button_label' | transloco }}
        </button>
      </form>
    </div>
  </div>
</section>
